import React from 'react';

import { truncateName } from '@eika-infrastruktur/format';
import { InfoLabel, Label } from '@eika/label';

import type { AccountOwner } from '../../../generated-types';
import { getRelevantOwner } from '../../../utils/mapper/accountSorter';

export interface Props {
    owners: AccountOwner[];
    className?: string;
}

const AccountLabels = ({ owners, className }: Props) => {
    const labels: ReturnType<typeof Label>[] = [];

    const relevantOwner = getRelevantOwner(owners);
    if (relevantOwner) {
        labels.push(<InfoLabel key="account_owner" text={truncateName(relevantOwner)} size="small" />);
    }

    if (labels.length > 0) {
        return <div className={className}>{labels}</div>;
    }
    return undefined;
};
export default AccountLabels;
